export default {
  mounted(el: HTMLElement) {
    // Focus the element
    el.focus();
  },
};
